export default __webpack_public_path__ + "static/media/map.9bff1abf.svg";